import { templateThemeTokens } from './templateThemeTokens.js';
import { THEME_DEFAULT_FONTS } from '@/contexts/CustomThemeConfigContext/constants.js';
import { createTheme } from '@/stitches/index.js';

export const dusk = createTheme({
  ...templateThemeTokens,
  colors: {
    defaultFont: '#000000',
    pageBackground: '#ADBECD',
    secondaryFont: '#FFFFFF',
  },
  fonts: {
    accent: THEME_DEFAULT_FONTS.sydney.dusk.accent
      ? THEME_DEFAULT_FONTS.sydney.dusk.accent.value
      : 'unset',
    body: THEME_DEFAULT_FONTS.sydney.dusk.body.value,
    heading: THEME_DEFAULT_FONTS.sydney.dusk.headline.value,
  },
  shadows: {
    basic10: '0 0 $64 rgba(228, 232, 247, 0.15)',
  },
});
